<script setup>
/* eslint-disable vue/require-v-for-key */
import { ref } from "vue";

const props = defineProps({
    tabs: {
        type: Array,
        default: () => [],
    },
    classes: {
        type: String,
        default: "",
    },
    fullWidth: {
        type: Boolean,
        default: false,
    },
});

const activeTab = ref(0);

const emit = defineEmits(["change"]);

function handleClick(idx) {
    activeTab.value = idx;
    emit("change", props.tabs[idx]);
}

function setActiveTab(idx) {
    activeTab.value = idx;
}

defineExpose({
    setActiveTab,
});
</script>

<template>
    <div
        class="act-type-tab d-flex flex-row flex-grow-1"
        :class="{[classes]: classes !== ''}"
    >
        <div
            class="cursor-pointer text-center tab-item"
            :data-test="tab.dataTest"
            v-for="(tab, tIdx) in props.tabs"
            :class="{
                'act-tab-active' : activeTab === tIdx,
                'w-100': fullWidth,
            }"
            @click="handleClick(tIdx)"
        >
            {{ tab.title }}
        </div>
    </div>
</template>
<style scoped>
.tab-item {
    width: max-content;
    padding-inline: 10px;
}

.act-tab-active {
    border-bottom: 4px solid #FFB700;
    padding-bottom: 4px;
}

.tab-text-bold .tab-item {
    font-weight: 600;
}
</style>
